// DEPENDENCIES
import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { useFormik } from 'formik';
import Moment from 'react-moment';
// COMPONENTS
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
// ICONS
import { FaRegListAlt } from 'react-icons/fa';
// CUSTOM COMPONENTS
import LoadingScreen from '../../components/LoadingScreen';
import Section from '../../components/Section';
import FormBlock from '../../components/FormBlock';
import ContentBlock from '../../components/ContentBlock';
import CustomBlock from '../../components/CustomBlock';
import ContentHeader from '../../components/ContentHeader';
import InputBlock from '../../components/InputBlock';
import Button from '../../components/Button';
import ActionBlock from '../../components/ActionBlock';
import SelectBlock from '../../components/SelectBlock';
// SERVICES AND HELPERS
import { Alert } from '../../helpers/Alert';
import * as Helper from '../../helpers/helper';
import * as CompanyService from '../../services/company.service';
import * as UserService from '../../services/user.service';

const ClientListManagePage = (props) => {
    const { location } = props
    const urlId = location.pathname.split('/').pop();
    const [userId, setProductId] = useState(parseInt(urlId) == urlId ? urlId : 0);

    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);

    const initialState = {
        id: 0,
        client: "",
        type: "",
        value: 0,
        isActive: true
    }

    const [client, setClient] = useState(initialState);
    const [type, setType] = useState(null);
    const [clients, setClients] = useState([]);
    const [audits, setAudits] = useState([]);
    const [showAudit, setShowAudit] = useState(false);

    useEffect(() => {
        setLoading(true);
        GetUsersClientList();
    }, [])

    const GetUsersClientList = () => {
        UserService.GetUsersClientList(userId)
            .then(res => {
                setClients(res);
                setLoading(false);
            }).catch(ex => {
                setLoading(false);
            });
    }

    const handleOnDragEnd = (result) => {
        if (!result.destination) return;

        const items = Array.from(clients);
        const [reorderedItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reorderedItem);

        setLoading(true);
        UserService.UpdateUsersClientList(items).then(res => {
            setClients(items);
            setLoading(false);
        }).catch(ex => {
            setLoading(false);
        });
    }

    const GetUserClientList = (id) => {
        UserService.GetUserClientList(id)
            .then(res => {
                setClient(res);
                formik.setFieldValue('client', res.client);
                formik.setFieldValue('value', res.value);
                setType(Helper.SetOptionModel(res.type));
            }).catch(ex => { });
    }

    const RemoveUserClientList = (id) => {
        UserService.RemoveUserClientList(id)
            .then(res => {
                GetUsersClientList();
            }).catch(ex => { });
    }

    const SubmitUserClientList = (userClientList) => {
        setSaving(true);
        UserService.SubmitUserClientList(userClientList)
            .then(res => {
                GetUsersClientList();
                Alert({ success: true, message: "Client has been saved!" });
                setSaving(false);
                formik.setFieldValue('client', "");
                formik.setFieldValue('value', 0);
                setType(null);
            }).catch(ex => {
                setSaving(true);
            });
    }

    const formik = useFormik({
        initialValues: client,
        enableReinitialize: true,
        onSubmit: (values, { setSubmitting }) => {
            SubmitUserClientList(values);
        }
    })

    return (
        <>
            {
                loading ?
                    <LoadingScreen /> :
                    <>
                        <CustomBlock className="main-container light--bg">
                            <Section>
                                <CustomBlock className="content-container--card-style">
                                    <ContentHeader
                                        title={(userId == 0 ? "Manage" : "View") + " Client List"}
                                        headerSize="sm"
                                    />
                                    {
                                        (userId == 0 && clients.length < 20) ?
                                            <FormBlock onSubmit={formik.handleSubmit} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                <ContentBlock cols={6}>
                                                    <InputBlock
                                                        id="client"
                                                        inputLabel="Client"
                                                        bordered
                                                        {...formik.getFieldProps("client")}
                                                    />
                                                </ContentBlock>
                                                <ContentBlock cols={3}>
                                                    <InputBlock
                                                        id="value"
                                                        inputLabel="Value"
                                                        bordered
                                                        {...formik.getFieldProps("value")}
                                                    />
                                                </ContentBlock>
                                                <ContentBlock cols={2}>
                                                    <SelectBlock
                                                        id="type"
                                                        inputLabel="Type"
                                                        bordered
                                                        value={type}
                                                        options={['Cod', 'Minnow', 'Whale'].map(x => Helper.SetOptionModel(x))}
                                                        onChange={option => {
                                                            option = option === null ? [] : option;
                                                            setType(option);
                                                            formik.setFieldValue("type", option.value);
                                                        }}
                                                    />
                                                </ContentBlock>
                                                <ContentBlock cols={1}>
                                                    <Button
                                                        text="Save"
                                                        type="submit"
                                                        className="success--bg fit-content"
                                                        style={{ marginTop: 10 }}
                                                        loading={saving}
                                                        disabled={saving}
                                                    />
                                                </ContentBlock>

                                            </FormBlock> : <></>
                                    }
                                    <DragDropContext onDragEnd={handleOnDragEnd}>
                                        <Droppable droppableId="clients">
                                            {(provided) => (
                                                <ul className="clients" {...provided.droppableProps} ref={provided.innerRef}>
                                                    {
                                                        clients.map(({ id, client, type, value }, index) =>
                                                            <Draggable key={`${id}`} draggableId={`${id}`} index={index}>
                                                                {(provided) => (
                                                                    <li
                                                                        ref={provided.innerRef}
                                                                        {...provided.draggableProps}
                                                                        {...provided.dragHandleProps}
                                                                    >
                                                                        {
                                                                            userId == 0 ?
                                                                                <ActionBlock
                                                                                    className="light--bg"
                                                                                    title={`${client} - ${type} ($${value.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')})`}
                                                                                    actionsPosition="left"
                                                                                    primaryActionText={"Edit"}
                                                                                    primaryActionBackground="info--bg"
                                                                                    primaryActionOnClick={() => { GetUserClientList(id) }}
                                                                                    secondaryActionText="Remove"
                                                                                    secondaryActionBackground="danger--bg"
                                                                                    secondaryActionOnClick={() => { RemoveUserClientList(id) }}
                                                                                    toggleIconPosition="right"
                                                                                    toggleIconBackground="lighter-blue--bg"
                                                                                    toggleIcon={
                                                                                        <FaRegListAlt size={20} className="darker-blue--clr" />
                                                                                    }
                                                                                    toggleIconOnClick={() => {
                                                                                        UserService.GetUserClientListAudits(id)
                                                                                            .then(res => {
                                                                                                setAudits(res);
                                                                                                setShowAudit(true);
                                                                                            }).catch(ex => { });
                                                                                    }}
                                                                                /> :
                                                                                <ActionBlock
                                                                                    className="light--bg"
                                                                                    title={`${client} - ${type} ($${value.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')})`}
                                                                                    toggleIconPosition="right"
                                                                                    toggleIconBackground="lighter-blue--bg"
                                                                                    toggleIcon={
                                                                                        <FaRegListAlt size={20} className="darker-blue--clr" />
                                                                                    }
                                                                                    toggleIconOnClick={() => {
                                                                                        UserService.GetUserClientListAudits(id)
                                                                                            .then(res => {
                                                                                                setAudits(res);
                                                                                                setShowAudit(true);
                                                                                            }).catch(ex => { });
                                                                                    }}
                                                                                />
                                                                        }
                                                                    </li>
                                                                )}
                                                            </Draggable>

                                                        )
                                                    }
                                                    {provided.placeholder}
                                                </ul>
                                            )}
                                        </Droppable>
                                    </DragDropContext>
                                </CustomBlock>
                            </Section>
                        </CustomBlock>

                        <Dialog
                            id="audit-dialog"
                            open={showAudit}
                            fullWidth="xl"
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle id="alert-dialog-title">{"Audit Log"}</DialogTitle>
                            <DialogContent>
                                {
                                    <>
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th>Audit</th>
                                                    <th>Date</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    audits.map((audit, index) =>
                                                        <tr>
                                                            <th>{audit.change}</th>
                                                            <th>
                                                                <Moment format="YYYY/MM/DD">
                                                                    {audit.changeDate}
                                                                </Moment>
                                                            </th>
                                                        </tr>
                                                    )
                                                }
                                            </tbody>
                                        </table>
                                    </>
                                }
                            </DialogContent>
                            <DialogActions>
                                <Button
                                    text="Close"
                                    className="danger--bg"
                                    onClick={() => setShowAudit(false)}
                                />
                            </DialogActions>
                        </Dialog>
                    </>
            }
        </>
    )
}

export default ClientListManagePage;